// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3874":"43a35eace7cb350a","4591":"919096de16d75b19","5849":"38b247e7a05b7be8"}[chunkId] + ".css";
};